import * as React from "react";
import { Text as TextPrimitive, Heading as HeadingPrimitive } from "@radix-ui/themes";
import { Responsive } from "@radix-ui/themes/dist/esm/props/prop-def.js";

interface HeadingProps {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  children: React.ReactNode;
  size?: Responsive<"1" | "2" | "3" | "4" | "5" | "6">;
  className?: string;
  style?: React.CSSProperties;
}

// Typography.tsx
export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(function Heading(
  { as, children, className = "", size = "1", ...props },
  ref,
) {
  return (
    <HeadingPrimitive ref={ref} as={as} size={size} className={className} {...props}>
      {children}
    </HeadingPrimitive>
  );
});

interface TextProps {
  children: React.ReactNode;
  size?: Responsive<"1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9">;
  className?: string;
  weight?: "light" | "regular" | "medium" | "bold";
  as?: "span" | "p" | "div" | "label" | undefined;
  style?: React.CSSProperties;
  title?: string;
}

export const Text = React.forwardRef<HTMLElement, TextProps>(function Text(
  { as = "span", children, size = "1", className = "", weight = "regular", style = {}, ...props },
  ref,
) {
  return (
    <TextPrimitive
      ref={ref}
      as={as}
      size={size}
      weight={weight}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </TextPrimitive>
  );
});
